import React from "react";
import PropTypes from "prop-types";
import MenuIcon from '@material-ui/icons/Menu';
import InboxIcon from '@material-ui/icons/Inbox';
import FingerPrintIcon from '@material-ui/icons/Fingerprint'
import AccountBoxIcon from '@material-ui/icons/AccountBox'
import HomeIcon from '@material-ui/icons/Home'

import {Link} from 'react-router-dom';

import {primaryColor} from "../../assets/jss/material-dashboard-react";

import {
    withStyles,
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    SwipeableDrawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText
} from "@material-ui/core";

const styles={
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    title:{
        flex:1
    },
    list: {
        width: 250,
    },
    appBar:{
        backgroundColor:primaryColor
    }
}

class PublicHeader extends React.Component {


    state={
        isOpen:false
    }
    toggleDrawer = (open) => () => {
        this.setState({
            isOpen: open
        });
    };


    render(){
    const {classes,title} = this.props




        const sideList = (
            <div className={classes.list}>
                <List>
                    <Link to="/">
                    <ListItem button>

                            <ListItemIcon>
                                <HomeIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Home" />

                    </ListItem>
                </Link>
                    <Link to="/login">
                        <ListItem  button>

                                <ListItemIcon>
                                    <FingerPrintIcon/>
                                </ListItemIcon>
                                <ListItemText primary="Login" />

                        </ListItem>
                    </Link>
                    <Link to="/register">
                    <ListItem button>

                            <ListItemIcon>
                                <AccountBoxIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Register" />

                    </ListItem>
                    </Link>
                </List>

            </div>
        );

        return(
            <AppBar className={classes.appBar} position="static">
                <Toolbar>
                    <IconButton onClick={this.toggleDrawer(true)} className={classes.menuButton} color="inherit" aria-label="Menu">
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="title" color="inherit" className={classes.title}>
                        {title}
                    </Typography>

                </Toolbar>
                <SwipeableDrawer
                    open={this.state.isOpen}
                    onClose={this.toggleDrawer(false)}
                    onOpen={this.toggleDrawer(true)}>
                    {sideList}
                </SwipeableDrawer>
            </AppBar>


        )

    }


}

export default withStyles(styles)(PublicHeader);


// WEBPACK FOOTER //
// ./src/components/PublicHeader/PublicHeader.jsx